import { Button, PreloaderCircular } from '@shared/ui/kit';
import stylex from '@stylexjs/stylex';
import { FC, useEffect, useState } from 'react';
import { styles } from './styles';

import { REQURED_PHRASE_MESSAGE, phraseValidator } from '@pages/event/lib/validator';
import { phoneNumberValidator } from '@shared/libs/phone-validator';
import { ModalWrapper } from '@shared/ui/modal-wrapper';
import { IOrganizer } from '../organizer/model/types';
import { InputWithClear } from './ui/InputWithClear';
import { colors } from '@shared/tokens/colors.stylex';
import { XmarkIcon } from '@shared/assets/icons';

interface IModalProps {
  closeHandle: () => void;
  addOrganizer: (organizer: Omit<IOrganizer, 'id'>) => void;
  active: boolean;
  fetching?: boolean;
}

export const ModalAddOrganizer: FC<IModalProps> = ({ active, closeHandle, addOrganizer, fetching = false }) => {
  const [lastName, setLastName] = useState('');
  const [firstName, setFirstName] = useState('');
  const [addBtnDisabled, setAddBtnDisabled] = useState(true);
  const [phone, setPhone] = useState('');
  const [phoneErrors, setPhoneErrors] = useState<string | false>(false);
  const [lastNameErrors, setLastNameErrors] = useState<string | false>(false);
  const [firstNameErrors, setFirstNameErrors] = useState<string | false>(false);

  const handleChangeNumber = (value: string) => {
    const formattedNumber = phoneNumberValidator(value);
    setPhone(formattedNumber);
  };

  useEffect(() => {
    // Телефон необязателен: проверяем формат, только если его начали заполнять
    if (!phone.trim()) {
      setPhoneErrors(false);
    } else if (phone.length < 17) {
      setPhoneErrors(`${REQURED_PHRASE_MESSAGE}`);
    } else {
      setPhoneErrors(false);
    }
  }, [phone]);

  useEffect(() => {
    if (!lastName.trim()) {
      setLastNameErrors('Поле фамилия не может быть пустым');
    } else {
      phraseValidator(lastName).then(setLastNameErrors);
    }
  }, [lastName]);

  useEffect(() => {
    if (!firstName.trim()) {
      setFirstNameErrors('Поле имя не может быть пустым');
    } else {
      phraseValidator(firstName).then(setFirstNameErrors);
    }
  }, [firstName]);

  useEffect(() => {
    const isDisabled = !!lastNameErrors || !!firstNameErrors || !!phoneErrors || !lastName || !firstName;
    setAddBtnDisabled(isDisabled);
  }, [lastNameErrors, firstNameErrors, phoneErrors, lastName, firstName, phone]);

  useEffect(() => {
    setLastName('');
    setFirstName('');
    setPhone('');
    setPhoneErrors(false);
    setLastNameErrors(false);
    setFirstNameErrors(false);
    setAddBtnDisabled(true);
  }, [active]);

  const handleClick = () => {
    addOrganizer({ lastName, firstName, phone });
  };

  if (!active) return;
  return (
    <ModalWrapper
      active={active}
      settingsContainer={{ height: 'auto', width: '480px', padding: '0px' }}
      settingsHeader={{ padding: '0px' }}
      settingsFooter={{ padding: '0px' }}
    >
      {fetching ? (
        <div {...stylex.props(styles.loaderContainer)}>
          <PreloaderCircular variant="secondary" size="large" />
        </div>
      ) : (
        <div {...stylex.props(styles.container)}>
          <div {...stylex.props(styles.headerContainer)}>
            <p {...stylex.props(styles.header)}>Создать нового организатора</p>
            <button onClick={closeHandle} {...stylex.props(styles.xMarkIcon)}>
              <XmarkIcon size="24" />
            </button>
          </div>

          <div {...stylex.props(styles.contentWrapper)}>
            <InputWithClear
              label="Фамилия *"
              value={lastName}
              onChange={setLastName}
              onClear={() => setLastName('')}
              placeholder="Введите фамилию"
              error={lastNameErrors}
              iconColor={colors.primaryIcon}
            />

            <InputWithClear
              label="Имя *"
              value={firstName}
              onChange={setFirstName}
              onClear={() => setFirstName('')}
              placeholder="Введите имя"
              error={firstNameErrors}
              iconColor={colors.primaryIcon}
            />

            <div {...stylex.props(styles.phoneInputWrapper)}>
              <InputWithClear
                label="Телефон"
                value={phone}
                onChange={handleChangeNumber}
                onClear={() => setPhone('')}
                placeholder="Введите телефон"
                error={phoneErrors}
                iconColor={colors.primaryIcon}
              />
            </div>
          </div>

          <div {...stylex.props(styles.actions)}>
            <Button
              onClick={() => closeHandle()}
              variant="secondary"
              size="small"
              settings={{ padding: '8px 20px', fontSize: '14px' }}
            >
              Отмена
            </Button>
            <Button
              onClick={handleClick}
              variant="accent"
              size="small"
              settings={{ padding: '8px 20px', fontSize: '14px' }}
              isDisabled={addBtnDisabled}
            >
              Создать
            </Button>
          </div>
        </div>
      )}
    </ModalWrapper>
  );
};
